
export const setDashboardUnfilteredData = (data) => ({
    type: 'SET_DA_UNFILTERED_DATA',
    payload: data
});

export const setMaxMinChartToggle = (data) => ({
    type: 'SET_MAX_MIN_CHART_TOGGLE',
    payload: data
});

const DASH_INITIAL_STATE = {
    dashboardUnfilteredData: [],
    maxMinChartToggle: false
};

export default function dashUnfilDReducer(state = DASH_INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_DA_UNFILTERED_DATA':
            return { ...state, dashboardUnfilteredData: action.payload };
        case 'SET_MAX_MIN_CHART_TOGGLE':
            return { ...state, maxMinChartToggle: action.payload };
        default:
            return state;
    }
}